module.exports = __webpack_public_path__ + "img/cabo-da-roca.3bcd4209.jpg";